import { MutedOutlined } from "@ant-design/icons";
import { Badge } from "antd";
import React, { useState } from "react";
import styleFromVariables from "variables.module.scss";

import { useAppSelector } from "app/hooks";

import AntTooltip from "components/AntTooltip";

import { appHasFirstInteractState } from "storeSlices/appSettings";

import style from "./MinimalSoundIndicator.module.scss";

export const MinimalSoundIndicator: React.FC = () => {
  const [showTooltip, setShowTooltip] = useState(true);

  const hasFirstInteract = useAppSelector(appHasFirstInteractState);

  if (hasFirstInteract) {
    return null;
  }

  return (
    <AntTooltip
      title="Включить звук уведомлений?"
      open={showTooltip}
      onOpenChange={setShowTooltip}
      placement="left"
      className={style.tooltipInnerStyle}
    >
      <div
        style={{
          position: "fixed",
          bottom: 26,
          left: 10,
          zIndex: 1000,
          background: "#fff",
          padding: 10,
          borderRadius: 18,
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          cursor: "pointer",
          transition: "all 0.3s",
          display: "flex",
        }}
        onClick={() => {}}
        onMouseEnter={() => setShowTooltip(true)}
      >
        <Badge
          dot
          offset={[-2, 2]}
          color={styleFromVariables.mainTextColor}
          rootClassName={style.badge}
        >
          <MutedOutlined
            style={{
              fontSize: 20,
              color: styleFromVariables.mainTextColor,
              padding: "0 4px",
            }}
          />
        </Badge>
      </div>
    </AntTooltip>
  );
};
